import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleFilterComponent } from './schedule-filter.component';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [ScheduleFilterComponent],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        ScheduleFilterComponent
    ]
})
export class ScheduleFilterModule { }
